import { type DrawerContent, useBuilder } from '../context';
import { FormSettings } from '../form-settings/FormSettings';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import { SideDrawer } from 'framework/ui/mui-builder';
import { ElementDrawer } from '../elementDrawer/ElementDrawer';
import { findElement } from '../../format/elements';
import { elementType } from '../fieldsPalette/tiles';
import { DrawerHeader } from './DrawerHeader';

interface DrawerHostProps {
  open: boolean;
  content: DrawerContent | null;
  onClose: () => void;
}

export const BuilderMainDrawer = ({ open, content, onClose }: DrawerHostProps) => {
  const { form } = useBuilder();
  const element = content?.kind === 'element' ? findElement(form, content.id) : undefined;
  const { name, icon: Icon } = element ? elementType(element) : { name: 'Form settings', icon: SettingsOutlined };
  return (
    <SideDrawer
      isOpen={open}
      onClose={onClose}
      variant="persistent"
      sx={{ display: 'contents' }}
      paperSx={{ position: 'absolute', height: '105%', width: 560 }}
      title={<DrawerHeader icon={<Icon />} title={name} />}
      width={560}
      content={
        <>
          {content?.kind === 'element' && <ElementDrawer key={content.id} id={content.id} />}
          {content?.kind === 'form' && <FormSettings />}
        </>
      }
    />
  );
};
